import { Card, CardContent, Divider, Typography } from "@mui/material";
import { FunctionComponent } from "react";

export const PermissionDenied: FunctionComponent = () => {
  return (
    <>
      <Card sx={{ maxWidth: "300px", margin: "auto" }}>
        <CardContent>
          <Typography
            variant="h4"
            sx={{ textAlign: "center", marginBottom: 2 }}
          >
            Permission Denied
          </Typography>
          <Divider />
          <Typography
            variant="body2"
            sx={{ textAlign: "center", marginTop: 2 }}
          >
            You do not have permission to view this page. Please contact your
            Simpallo Administrator
          </Typography>
        </CardContent>
      </Card>
    </>
  );
};
